import { SocialIconsData } from '@lib/types/SocialIcons'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { FC } from 'react'

interface props {
  data?: SocialIconsData
}

const SocialIcons: FC<props> = ({ data }) => {
  if (!data) return <></>
  const { facebook, instagram, youtube, pinterest, tiktok, width, height } = data
  return (
    <div className="flex gap-10">
      {instagram?.icon?.url && (
        <Link href={instagram?.link || '/'} target="_blank" rel="noreferrer" passHref>
          <Image
            className="rounded-full"
            src={instagram.icon.url.replace('sheetsociety.cdn.prismic.io', 'ss-prismic-content-api.b-cdn.net')} // test case for bunny cdn
            alt={instagram.icon.alt || 'Facebook'}
            width={width ? Number(width) : 24}
            height={height ? Number(height) : 24}
          />
        </Link>
      )}
      {facebook?.icon?.url && (
        <Link href={facebook?.link || '/'} target="_blank" rel="noreferrer" passHref>
          <Image
            className="rounded-full"
            src={facebook.icon.url}
            alt={facebook.icon.alt || 'Facebook'}
            width={width ? Number(width) : 24}
            height={height ? Number(height) : 24}
          />
        </Link>
      )}

      {pinterest?.icon?.url && (
        <Link href={pinterest?.link || '/'} target="_blank" rel="noreferrer" passHref>
          <Image
            className="rounded-full"
            src={pinterest.icon.url}
            alt={pinterest.icon.alt || 'Facebook'}
            width={width ? Number(width) : 24}
            height={height ? Number(height) : 24}
          />
        </Link>
      )}
      {youtube?.icon?.url && (
        <Link href={youtube?.link || '/'} target="_blank" rel="noreferrer" passHref>
          <Image
            className="rounded-full"
            src={youtube.icon.url}
            alt={youtube.icon.alt || 'Facebook'}
            width={width ? Number(width) : 24}
            height={height ? Number(height) : 24}
          />
        </Link>
      )}
      {tiktok?.icon?.url && (
        <Link href={tiktok?.link || '/'} target="_blank" rel="noreferrer" passHref>
          <Image
            src={tiktok.icon.url}
            alt={tiktok.icon.alt || 'Tiktok'}
            width={width ? Number(width) : 24}
            height={height ? Number(height) : 24}
          />
        </Link>
      )}
    </div>
  )
}

export default SocialIcons
